import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function UpdateCMFileAssetNameService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/renameCMFileAsset`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
            return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while renaming the file. please try again later.");
        return false;
    });
}

export default UpdateCMFileAssetNameService;